import { render, staticRenderFns } from "./agent_flow_header.vue?vue&type=template&id=22d017ac"
import script from "./agent_flow_header.vue?vue&type=script&lang=js"
export * from "./agent_flow_header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports